import { useSelector } from 'react-redux';

import type { OrgPositionDetail } from '@appTypes/esb/organizations/positions/_orgGuid';
import { organizationGuidSel } from '@context';
import {
  useGetOrgAdultsQuery,
  useGetUnitRosterAdultsQuery,
} from '@modules/roster/api';
import {
  useGetOrgPositionsQuery,
  useGetOrganizationProfileQuery,
} from '@modules/rtk/esb-api';

import { RosterAdultMemberExtended } from '../permissionsTab/utils';

export function useUnitRosterAdults() {
  const organizationGuid = useSelector(organizationGuidSel);
  const data = useGetUnitRosterAdultsQuery(
    {
      organizationGuid,
    },
    {
      skip: !organizationGuid,
    },
  );

  return data;
}

export function useOrgUnitRosterAdults() {
  const organizationGuid = useSelector(organizationGuidSel);
  const data = useGetOrgAdultsQuery(
    {
      organizationGuid,
      body: { includeRegistrationDetails: true, includeExpired: true },
    },
    {
      skip: !organizationGuid,
    },
  );

  return data;
}

export function useOrgPositions() {
  const organizationGuid = useSelector(organizationGuidSel);
  const data = useGetOrgPositionsQuery(
    {
      organizationGuid,
    },
    {
      skip: !organizationGuid,
    },
  );

  return data;
}

export function useOrgProfile() {
  const organizationGuid = useSelector(organizationGuidSel);
  const data = useGetOrganizationProfileQuery(
    {
      orgGuid: organizationGuid,
    },
    {
      skip: !organizationGuid,
    },
  );

  return data;
}

// TODO this is for mocking propuses It might or might not get removed
export function useUnitRosterAdultsWithPositions() {
  const organizationGuid = useSelector(organizationGuidSel);
  const {
    isFetching: loadingRosterAdults,
    data: rosterAdults = { users: [], unitType: '' },
  } = useGetUnitRosterAdultsQuery(
    {
      organizationGuid,
    },
    {
      skip: !organizationGuid,
    },
  );

  const {
    isFetching: loadingOrgPositions,
    data: orgPositions = { Positions: [] },
  } = useGetOrgPositionsQuery(
    {
      organizationGuid,
    },
    {
      skip: !organizationGuid,
    },
  );

  const data: RosterAdultMemberExtended[] = rosterAdults.users.map(user => {
    const userOrgPositions = orgPositions.Positions.filter(
      (pos: OrgPositionDetail) =>
        pos.personsAssigned.some(
          ({ personGuid }) => personGuid === user.personGuid,
        ),
    );

    return { ...user, userOrgPositions };
  });

  return {
    loading: loadingRosterAdults || loadingOrgPositions,
    data,
    unitType: rosterAdults.unitType,
  };
}
